import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = [
  <path
    key="1"
    d="M13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9L11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20L13 9Z"
  />,
  <path key="2" d="M7 12L5 12L5 20C5 20.5523 5.44772 21 6 21C6.55228 21 7 20.5523 7 20L7 12Z" />,
  <path
    key="3"
    d="M19 15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15L17 20C17 20.5523 17.4477 21 18 21C18.5523 21 19 20.5523 19 20L19 15Z"
  />,
  <path
    key="4"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.15374 5.74194C5.19302 7.1248 5 8.5828 5 9L5 9.99956L6.97117 9.99999C6.98709 9.99999 7 9.98709 7 9.97117L7 9.00239C7 9.0023 7.00023 8.99791 7.00024 8.99782C7.00115 8.98334 7.00544 8.91581 7.02412 8.79739C7.0451 8.66434 7.08112 8.48739 7.13965 8.28253C7.25739 7.87044 7.46 7.36706 7.79626 6.88306C8.437 5.96077 9.63217 5 12 5C14.3229 5 15.5266 6.04509 16.1904 7.05084C16.5356 7.57395 16.7434 8.10379 16.864 8.5061C16.9239 8.70566 16.961 8.86927 16.9826 8.97858C16.9933 9.03309 17.0001 9.07368 17.0039 9.09798L17.0074 9.1218C17.0073 9.12068 17.0077 9.12004 17.0088 9.11989C17.0209 9.11826 17.1238 9.10514 18 9C18.8976 8.89229 18.9836 8.88106 18.9919 8.8799C18.9925 8.87981 18.9927 8.87946 18.9926 8.87886L18.9926 8.87855L18.9923 8.87579L18.9914 8.86885L18.9888 8.84952C18.9867 8.83423 18.9838 8.81419 18.98 8.78971C18.9724 8.74078 18.961 8.67394 18.9448 8.59174C18.9124 8.42761 18.8605 8.20059 18.7797 7.9314C18.6191 7.39621 18.3394 6.67605 17.8596 5.94916C16.8734 4.45491 15.0771 3 12 3C8.96783 3 7.163 4.28923 6.15374 5.74194Z"
  />,
  <path key="5" d="M14 8L18 12L22 8L14 8Z" />,
];

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.80911 4.11152C4.29517 4.72825 4.06506 5.58379 4.06506 6.49988C4.06506 6.81192 3.8121 7.06488 3.50006 7.06488C3.18802 7.06488 2.93506 6.81192 2.93506 6.49988C2.93506 5.41591 3.20495 4.27141 3.94101 3.38812C4.69218 2.48671 5.86419 1.93481 7.50006 1.93481C9.13593 1.93481 10.3079 2.48671 11.0591 3.38812C11.7154 4.1757 12.0011 5.17094 12.0553 6.14579L13.1005 5.10054C13.3212 4.8799 13.6789 4.8799 13.8996 5.10054C14.1202 5.32119 14.1202 5.67893 13.8996 5.89957L11.8996 7.89957C11.6789 8.12022 11.3212 8.12022 11.1005 7.89957L9.10054 5.89957C8.8799 5.67893 8.8799 5.32119 9.10054 5.10054C9.32119 4.8799 9.67893 4.8799 9.89957 5.10054L10.9216 6.1226C10.8658 5.35102 10.6337 4.6427 10.191 4.11152C9.69218 3.51292 8.86419 3.06481 7.50006 3.06481C6.13593 3.06481 5.30793 3.51292 4.80911 4.11152ZM7.50006 5.93506C7.8121 5.93506 8.06506 6.18802 8.06506 6.50006V13.5001C8.06506 13.8121 7.8121 14.0651 7.50006 14.0651C7.18802 14.0651 6.93506 13.8121 6.93506 13.5001V6.50006C6.93506 6.18802 7.18802 5.93506 7.50006 5.93506ZM3.50006 8.43506C3.8121 8.43506 4.06506 8.68802 4.06506 9.00006V13.5001C4.06506 13.8121 3.8121 14.0651 3.50006 14.0651C3.18802 14.0651 2.93506 13.8121 2.93506 13.5001V9.00006C2.93506 8.68802 3.18802 8.43506 3.50006 8.43506ZM11.5001 9.93506C11.8121 9.93506 12.0651 10.188 12.0651 10.5001V13.5001C12.0651 13.8121 11.8121 14.0651 11.5001 14.0651C11.188 14.0651 10.9351 13.8121 10.9351 13.5001V10.5001C10.9351 10.188 11.188 9.93506 11.5001 9.93506Z"
  />
);

export const DataGridCustomizationColsIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="DataGridCustomizationCols" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
